// @flow
import styled from 'styled-components';

export const Base = styled.div`width: 100%;`;

export const Label = styled.div`
    color: ${p => p.theme.secondaryBase};
    font-size: 0.8em;
`;

export const DropdownContainer = styled.div`font-size: 0.8em;`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/action-attribute/attribute-types/select/styles.js